import React from 'react';
import Page from '../page';
export default function ByChannel() {
  return <Page type="channel" pageName="By_Channel"></Page>;
}
